import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useDarkMode } from '@/composables/useDarkMode';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MGExpansionPanel',
    props: {
        color: { default: '#ffffff' },
        variant: { default: 'default' },
        elevation: { default: 0 }
    },
    setup(__props) {
        const { isDarkMode } = useDarkMode();
        return (_ctx, _cache) => {
            const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title");
            const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text");
            const _component_v_expansion_panel = _resolveComponent("v-expansion-panel");
            const _component_v_expansion_panels = _resolveComponent("v-expansion-panels");
            return (_openBlock(), _createBlock(_component_v_expansion_panels, {
                color: _ctx.color,
                variant: _ctx.variant,
                elevation: _ctx.elevation,
                class: _normalizeClass(["mg-expansion-panels", { dark: _unref(isDarkMode) }])
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, null, {
                                actions: _withCtx(({ expanded }) => [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["mg-expand-triangle", { expanded }])
                                    }, "▼", 2)
                                ]),
                                default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "title")
                                ]),
                                _: 3
                            }),
                            _createVNode(_component_v_expansion_panel_text, null, {
                                default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "default")
                                ]),
                                _: 3
                            })
                        ]),
                        _: 3
                    })
                ]),
                _: 3
            }, 8, ["color", "variant", "elevation", "class"]));
        };
    }
});
